import { Box, Text } from '@radix-ui/themes';

export default function MainContentHeader({ content }) {
    return (
        <Box>
            <Text size="2" color="gray" style={{ 
                fontSize: '17px', 
                fontWeight: '600', 
                lineHeight: '1.6',
                fontFamily: 'LXGW WenKai Screen, PingFang SC, Hiragino Sans GB, Microsoft YaHei, sans-serif'
            }}>
                {content}
            </Text>
        </Box>
    )
}